import { apiClient, handleResponse } from './axios';

async function getSkills() {
  try {
    const response = await apiClient.get('/skill');
    const skill = await handleResponse(response);
    return skill;
  } catch (error) {
    return error.response;
  }
}

async function getSkill(skillId) {
  try {
    const response = await apiClient.get(`/skill/${skillId}`);
    const skill = await handleResponse(response);
    return skill;
  } catch (error) {
    return error.response;
  }
}

async function addSkill(body) {
  try {
    const response = await apiClient.post('/skill', body);
    const skill = await handleResponse(response);
    return skill;
  } catch (error) {
    return error.response;
  }
}

async function updateSkill(skillId, body) {
  try {
    const response = await apiClient.put(`/skill/${skillId}`, body);
    const skill = await handleResponse(response);
    return skill;
  } catch (error) {
    return error.response;
  }
}

async function deleteSkill(skillId) {
  try {
    const response = await apiClient.delete(`/skill/${skillId}`);
    const skill = await handleResponse(response);
    return skill;
  } catch (error) {
    return error.response;
  }
}
async function deleteSpecificSkill(skillId) {
  try {
    const response = await apiClient.delete(`/skill/specific/${skillId}`);
    const skill = await handleResponse(response);
    return skill;
  } catch (error) {
    return error.response;
  }
}

const skillTitleServices = {
  getSkills,
  getSkill,
  addSkill,
  updateSkill,
  deleteSkill,
  deleteSpecificSkill,
};

export default skillTitleServices;
